var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('span',{staticClass:"back_content",on:{"click":_vm.handleBack}},[_vm._v(_vm._s(_vm.$t('home.back')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }